import { create } from 'zustand';

interface ExportsSessionStore {
	/**
	 * Authority (base58) that has requested an export this session, or null.
	 * Gates the app-level background poll in `useDownloadRequests` so the
	 * (signature-gated) exports query is not fetched — and no signature is
	 * prompted — just for loading the app. Set by `useRequestExport` after a
	 * successful POST. Keyed by authority so a wallet/account switch does not let
	 * the next authority inherit the opt-in and trigger a fetch without a fresh
	 * request of its own.
	 */
	requestedExportAuthority: string | null;
	setRequestedExportAuthority: (authority: string) => void;
	/**
	 * Authority (base58) that has explicitly opted to load the exports table this
	 * session, or null. Gates the (signature-gated) exports query in the table
	 * view so viewing the Exports tab does not auto-prompt a wallet signature on
	 * mount; set by the "View my exports" button. Keyed by authority for the same
	 * reason as `requestedExportAuthority`.
	 */
	unlockedExportsAuthority: string | null;
	setUnlockedExportsAuthority: (authority: string) => void;
}

const useExportsSessionStore = create<ExportsSessionStore>((set) => ({
	requestedExportAuthority: null,
	setRequestedExportAuthority: (authority) =>
		set({ requestedExportAuthority: authority }),
	unlockedExportsAuthority: null,
	setUnlockedExportsAuthority: (authority) =>
		set({ unlockedExportsAuthority: authority }),
}));

export default useExportsSessionStore;
